import { Link } from "react-router";
import { directoryPath, mentionParts } from "@klantpunt/shared";
import { useMe } from "../../lib/auth";

/**
 * Logboektekst met @-vermeldingen als label; jezelf genoemd valt extra op. Een bedrijf of contact uit het
 * adresboek is een link naar het adresboek.
 */
export function MentionText({ body }: { body: string }) {
  const { data: me } = useMe();
  return (
    <>
      {mentionParts(body).map((p, i) => {
        if ("text" in p) return <span key={i}>{p.text}</span>;
        const m = p.mention;
        if (m.kind !== "user")
          return (
            <Link key={i} className="mention ref" to={directoryPath(m.kind, m.id)}>
              @{m.name}
            </Link>
          );
        return (
          <span key={i} className={`mention${m.id === me?.user.id ? " me" : ""}`}>
            @{m.name}
          </span>
        );
      })}
    </>
  );
}
